import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import AdminProgramSubscriptions from './AdminProgramSubscriptions';

function AdminSubscriptions() {
  return (
    <>
      <Helmet>
        <title>BVT Admin - Subscriptions</title>
      </Helmet>
      <AdminProgramSubscriptions />
    </>
  );
}

export default AdminSubscriptions;